export const NEW_DATA_EVENT = "NEW_DATA_EVENT";
export const API_RESPONSE_EVENT = "API_RESPONSE_EVENT";
export const API_SAVE_AUDIO_EVENT = "API_SAVE_AUDIO_EVENT";
export const API_SAVE_MCQ_EVENT = "API_SAVE_MCQ_EVENT";
export const API_SAVE_CHAT_EVENT = "API_SAVE_CHAT_EVENT";
export const QUESTION_PREVIEW_EVENT = "QUESTION_PREVIEW_EVENT";
export const SCRIPTED_RECORDING_TIME = 59;
export const SPONTANEOUS_RECORDING_TIME = 59;
export const NOT_REQUIRED = "NOT_REQUIRED";

export const ORGANIZATIONS = {
  WIZR: "Wizr",
  SPOTLIGHT: "Spotlight"
};

export const QUESTION_TYPE = {
  MCQ: "mcq",
  FREE_TEXT: "free_text",
  BREAKER_SCREEN: "breaker_screen",

  // speech
  SPEECH_SCRIPTED: "speech_scripted",
  SPEECH_SPONTANEOUS: "speech_spontaneous",

  // writing
  TYPING_TEST: "typing_text",
  TEXT_COMPLETION: "sentence_completion",

  // chat
  CHAT: "chat",
};

export const MEDIA_TYPE = {
  TEXT: "text",
  IMAGE: "image",
  AUDIO: "audio",
  VIDEO: "video",
  EMBED: "embed",
};

export const ESCAPE_HTML_COMPONENT = {
  QUESTION: "Question",
  OPTION: "Option"
};

export const PAUSE_TIMER_EVENT = "PAUSE_TIMER_EVENT"
export const RESUME_TIMER_EVENT = "RESUME_TIMER_EVENT"

export const QUIZ_DATA = {
  id: "34ddf950-f96b-431c-b6ee-c5039a01ff30",
  title: "Test Quiz",
  timer: null,
  description:
    "In this section, you will be asked some questions on digital capability, read those questions carefully and answer them.",
  questions: [
    {
      id: "95cec7f1-80dc-4c8d-8b3e-13b2cd0d6ddc",
      question:
        "You received a phone number in SMS, which application will you use to access the number?",
      type: "mcq",
      timer: 10,
      media: [
        {
          mediaUrl:
            "https://images.unsplash.com/photo-1668979482402-be40413c4b9e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=735&q=80",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "f47c3d65-a996-417e-91ed-427d906f959b",
          type: "text",
          text: "A",
          mediaUrl: null,
        },
        {
          id: "b649e6d8-982b-473c-8476-22b9ecf64f2f",
          type: "text",
          text: "B",
          mediaUrl: null,
        },
        {
          id: "0d4d80fe-a8f1-4195-9942-193a51c45bca",
          type: "text",
          text: "C",
          mediaUrl: null,
        },
        {
          id: "99df4a96-f173-432b-9a99-069f3361878f",
          type: "text",
          text: "D",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "f2dfa194-0329-4c15-8f58-0d685a0135ce",
      question:
        "How many hours will it take you to reach Lotus Temple, New Delhi?",
      type: "mcq",
      timer: 10,
      media: [
        {
          mediaUrl: "https://unberry.s3.ap-south-1.amazonaws.com/unberry/map",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "e8534a6c-9a77-4d96-bc10-f7430ed30774",
          type: "text",
          text: "1 H",
          mediaUrl: null,
        },
        {
          id: "2b8d89ef-2b20-4b6e-bff7-c04c39fbdaad",
          type: "text",
          text: "2 H",
          mediaUrl: null,
        },
        {
          id: "3ad11198-f9c7-412b-b224-14d2cbded654",
          type: "text",
          text: "7 H",
          mediaUrl: null,
        },
        {
          id: "7f22963d-8d73-490f-bb3d-320737df4040",
          type: "text",
          text: "11 H",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "382089289304",
      question: `Find the missing number (?) in the image above`,
      media: [{ mediaUrl: "https://image.url", mediaType: "image" }],
      imageUrl:
        "https://images.unsplash.com/photo-1451324119451-db0ac857463c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
      options: [],
      type: QUESTION_TYPE.FREE_TEXT,
      timer: 10000, //ms
    },
  ],
};

export const CHAT_QUIZ = {
  id: "91fce5ab-21e7-4dde-94df-bcea36d4a7ae",
  title: "Chat GPT quiz",
  timer: 120,
  description: {},
  questions: [
    {
      "id": "eb64e587-dd97-4b3c-8590-d8a85a3acf0d",
      "question": "<head></head><body><p><strong>Objective:</strong></p><p>The purpose of this exercise is to evaluate your customer service skills, particularly your ability to handle complex inquiries, provide detailed explanations, and ensure customer satisfaction. You will engage in a simulated chat conversation with a customer from Zomato, a food delivery platform.</p><p><br></p><p><strong>Scenario Overview:</strong></p><p>You are a Customer Service Executive responsible for providing support for Zomato. You will be interacting with Arjun, a customer who has experienced issues with their recent order, including late delivery and incorrect items.</p><p><br></p><p><strong>Follow these instructions:</strong></p><ol><li><p>Apologize for the inconvenience and assure the customer that you will investigate the issue.</p></li><li><p>Acknowledge the late delivery and apologize for it, offering a token of goodwill (e.g., a discount on the next order).</p></li><li><p>Offer a replacement for the incorrect items or provide a refund if the customer prefers.</p></li><li><p>If the customer prefers a refund, clarify that refunds take a minimum of 5 working days and provide a random reference number if requested.</p></li></ol><p><br></p><p><strong>Duration of the Exercise:</strong></p><p>The conversation should last about 5-10 minutes, aiming to swiftly and effectively resolve the customer’s concerns while enhancing their overall satisfaction with the service.</p></body>",
      "type": "chat",
      "timer": 0,
      "createdAt": "2024-07-02T08:56:04.229Z",
      "updatedAt": "2024-07-02T08:58:03.633Z",
      "mediaIds": [],
      "embedUrl": null,
      "maxScore": 4,
      "analysisPrompt": "e3f77cab-eb76-46fc-a901-d6e913eec955",
      "completionPrompt": "7a67024b-61b5-4c45-a61b-f2c7e7d23e1a",
      "level": "easy",
      "timeToSolve": 40,
      "transcriptSource": null,
      "displayType": null,
      "randomizeOptions": false,
      "options": [],
    },
    {
      "id": "323543f3-4eef-4506-92df-57d310943e6f",
      "question": "<head></head><body><p>Remember! You’re a customer service agent at a company that helps customers with their issues. You have a new query. Chat with the customer to help resolve their issue.</p><p><br></p><p><strong>Things to remember: </strong></p><p>Ask the customer about product details &amp; issues</p><p>Offer a replacement for the product first</p><p>In case the customer says no to a replacement, offer a full refund</p><p><br></p><p><strong>Things to keep in mind:</strong></p><p>Number of days for successful refund: 2 days</p><p>Number of days in case of replacement: 7 days</p><p><br></p></body>",
      "type": "chat",
      "timer": 0,
      "createdAt": "2023-10-05T10:46:44.741Z",
      "updatedAt": "2024-02-02T08:32:13.904Z",
      "mediaIds": [],
      "embedUrl": null,
      "maxScore": 10,
      "analysisPrompt": "94fa7431-0421-4eea-9ce8-e2cd5779f8c3",
      "completionPrompt": "5f252c31-f228-452d-a570-560771a69fa6",
      "level": "easy",
      "timeToSolve": 40,
      "transcriptSource": null,
      "displayType": null,
      "randomizeOptions": false,
      "options": [],
    },
    {
      "id": "1779f303-c449-4c30-8793-8c963a7f8467",
      "question": "<head></head><body><h3>Objective:</h3><p>The purpose of this exercise is to evaluate your customer service skills, particularly your ability to handle complex inquiries, provide detailed explanations, and ensure customer satisfaction. You will engage in a simulated chat conversation with a customer from a major US telecom provider.</p><p><br></p><h3>Scenario Overview:</h3><p>You are a Customer Service Executive responsible for providing support for a US telecom provider. You will be interacting with Jamie Wallace, a customer who has experienced multiple service disruptions over the past week, including dropped calls and slow data speeds, which have impacted their ability to work remotely. Additionally, Jamie has noticed incorrect billing charges on their latest invoice, presumably related to an overcharge for data usage.</p><p><br></p><h3>Follow these instructions:</h3><ol><li><p>Guide the customer to perform a network settings reset if they express concerns about service disruptions.</p></li><li><p>If the steps for a network settings reset are asked, instruct them to go to settings, select 'Mobile Network', and click on 'Network settings reset'.</p></li><li><p>If dissatisfaction persists, suggest checking their area for any ongoing service maintenance that could explain the connectivity issues.</p></li><li><p>If a refund is requested due to the billing errors, clarify that refunds take a minimum of 10 working days.</p></li><li><p>If a reference number for the refund is asked, provide a random number as the reference number.</p></li></ol><p><br></p><h3>Duration of the Exercise:</h3><p>The conversation should last about 5-10 minutes, aiming to swiftly and effectively resolve the customer’s concerns while enhancing their overall satisfaction with the service.</p></body>",
      "type": "chat",
      "timer": 0,
      "createdAt": "2024-06-27T02:21:14.870Z",
      "updatedAt": "2024-06-27T02:43:19.319Z",
      "mediaIds": [],
      "embedUrl": null,
      "maxScore": 4,
      "analysisPrompt": "e3f77cab-eb76-46fc-a901-d6e913eec955",
      "completionPrompt": "c5f282de-93e4-4989-abbf-b14f6f65c70c",
      "level": "easy",
      "timeToSolve": 40,
      "transcriptSource": null,
      "displayType": null,
      "randomizeOptions": false,
      "options": [],
    }
  ]
}

export const FUNDAMENTAL_QUIZ = {
  id: "6037cded-b0d2-4209-885b-3aa7bc8f9c16",
  title: "Fundamentals",
  timer: 900,
  description:
    "In this section, you will be asked some questions on basic fundamentals, read those questions carefully and answer them.",
  questions: [
    {
      id: "7def3c3f-1848-4050-9b63-b9e47568efe7",
      question:
        "Package with this label should be loaded in truck going to which city?",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "e88c8741-cf3f-4169-bb9f-c1e7366a7883",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Group%20143e9387bb-054a-4eaa-9c5f-5085d0a9e29e.png",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "fa5f30b1-605a-4ee5-a4de-03709562d1df",
          type: "text",
          text: "ARH8861JH",
          mediaUrl: null,
        },
        {
          id: "effeb98f-2a12-4f04-bf52-1a08711ca34f",
          type: "text",
          text: "Madurai",
          mediaUrl: null,
        },
        {
          id: "6bc29417-cdf5-4211-88f0-744d5b6fb589",
          type: "text",
          text: "Avinas Road",
          mediaUrl: null,
        },
        {
          id: "555bebf7-288b-4413-b04b-271271b41905",
          type: "text",
          text: "Coimbatore",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "f1492493-c6fd-4e25-98c3-e9aa001910eb",
      question: "In the map below what is the destination?",
      // type: "mcq",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "2ff85f66-5278-4590-a1e8-0de59c130760",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/IMG_3770%201691acb9e-47a2-4ab9-b1e5-28020552026f.png",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "4012b1c2-acca-4900-8ced-d7a63b0b711f",
          type: "text",
          text: "Bhopal",
          mediaUrl: null,
        },
        {
          id: "7e726fbe-c8d5-4c10-b688-3e560853ca35",
          type: "text",
          text: "Sagar",
          mediaUrl: null,
        },
        {
          id: "175d54d3-5e93-452e-979a-b762d53740bc",
          type: "text",
          text: "Jabalpur",
          mediaUrl: null,
        },
        {
          id: "e225ebbf-7444-452c-b383-d6953e42baa8",
          type: "text",
          text: "Gwalior",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "78325264-f455-41dc-b385-d106e8278c6a",
      question:
        "If the final cost of Product A is Rs 50,000 then, what will be the cost of Raw Material?",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "3a137af4-e32b-4d31-9c52-d1d52d7d3e62",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Screenshot%202022-10-20%20at%20113ae02965-186a-4c61-8386-0eb62d996385.png",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "d19610e7-9e28-4d82-9b3a-0e0bc4f208c6",
          type: "text",
          text: "10000",
          mediaUrl: null,
        },
        {
          id: "6db4ef1b-e6bf-468c-9450-2ea098897a53",
          type: "text",
          text: "20000",
          mediaUrl: null,
        },
        {
          id: "b6d2ca33-feed-4d5a-85bc-719f2c99ff25",
          type: "text",
          text: "7000",
          mediaUrl: null,
        },
        {
          id: "3cd5528a-d78d-4c1f-9c4d-b9686427e6f3",
          type: "text",
          text: "7500",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "72528024-35ac-42e9-83f1-c4a40ad24114",
      question: "In which year was the maximum rise in production of wool?",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "3c4aa71a-b055-4182-b0a3-b1a0843f03aa",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Group%2036%20%282%2975eaf149-241b-4191-86db-fef9144de697.jpeg",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "585445fe-93e0-4915-80ec-c3ecbb46bae9",
          type: "text",
          text: "2014-15",
          mediaUrl: null,
        },
        {
          id: "754a1d2d-8de6-4d62-9d14-1fa2906d7c2c",
          type: "text",
          text: "2015-16",
          mediaUrl: null,
        },
        {
          id: "75f99184-e3f3-48f6-ace9-09b08ac31655",
          type: "text",
          text: "2017-18",
          mediaUrl: null,
        },
        {
          id: "bb911eaf-16c9-4c1a-8838-fee4fe29c4d2",
          type: "text",
          text: "2013-14",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "60f13833-931a-4294-b8f2-d977d3e37400",
      question:
        "Which of these lines would indicate a 'trend line' in a chart in excel?",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "56b2344b-3474-47ae-af19-5e9f66868a7c",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Group%20373d4d68ae-d588-421c-8e2b-4a11d4de0fb6.png",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "2e733700-913d-41ab-ab44-bf23019b7500",
          type: "text",
          text: "D",
          mediaUrl: null,
        },
        {
          id: "6f4a04d8-6ea9-4d19-9b41-fdf9305692db",
          type: "text",
          text: "C",
          mediaUrl: null,
        },
        {
          id: "f828b1b1-aea9-488a-a9eb-432335586d79",
          type: "text",
          text: "B",
          mediaUrl: null,
        },
        {
          id: "f032c1e5-781c-4fb9-98d9-bce7d208c214",
          type: "text",
          text: "A",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "5d029832-e697-41dd-8f06-5c48505c08c4",
      question: "Which one is not a function in MS Excel?",
      type: "mcq",
      timer: null,
      media: [],
      options: [
        {
          id: "a99ba068-d32a-4324-bfaf-a639c302e959",
          type: "text",
          text: "MIN",
          mediaUrl: null,
        },
        {
          id: "ab0f7538-6b79-430e-b257-f7dae2f5a34c",
          type: "text",
          text: "AVG",
          mediaUrl: null,
        },
        {
          id: "3b85470b-6eac-46b2-b28d-bc68756e770b",
          type: "text",
          text: "MAX",
          mediaUrl: null,
        },
        {
          id: "3d1f1ffd-d0c1-4746-bcda-2a7a435cfa39",
          type: "text",
          text: "SUM",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "1fa2e34b-59f0-4775-9f0b-5ccbd24e8ca0",
      question:
        "Which formula will count the number of values in the cell range A2:A5?",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "e20636bc-fd01-48de-ae65-85a5f6975044",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Screenshot%202022-10-18%20at%20118c7c6856-5585-41f4-900f-199d14801357.png",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "67b64be8-62c9-43b7-b972-97abf52b3c81",
          type: "text",
          text: "=COUNT(A1:A5)",
          mediaUrl: null,
        },
        {
          id: "1957027a-65c7-4f69-84e0-edcff9c36aa9",
          type: "text",
          text: "=COUNTIF(A2:A5)",
          mediaUrl: null,
        },
        {
          id: "a6f1d9bf-4c36-4c45-a222-f2775ae92581",
          type: "text",
          text: "=COUNT(A2:A5)",
          mediaUrl: null,
        },
        {
          id: "fdd31174-dbe5-4d94-8f54-018a7f61554b",
          type: "text",
          text: "=COUNTA(A2:A5)",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "dc828416-3c51-4e61-ba45-424188c482b2",
      question:
        "Please remember below shipping signs and their instructions. Use this information to answer the next set of questions.",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "b716aef4-5af3-48f3-8afe-654af56df115",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/96c7dbeb3-b387-48eb-b0cc-1b900abec30f.jpeg",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "3fcf3c93-0eec-460e-bd7f-92c26d73373c",
          type: "text",
          text: "Continue",
          mediaUrl: null,
        },
        {
          id: "c6c34a88-d960-419f-94c2-19d4f9c8f2fd",
          type: "text",
          text: "Next",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "f439fff5-e354-4c2a-adc7-97a7cbf63e84",
      question:
        "What is the delivery station and tracking number for this package label?",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "9fa35ea7-4f38-4051-9fff-5a33715fbf71",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Group%2014ba2f36eb-aab6-4606-8654-473325272192.jpeg",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "073824de-21fc-4787-8e27-875839530be1",
          type: "text",
          text: "Hampi, ARH8861JH",
          mediaUrl: null,
        },
        {
          id: "dca6b62b-bf08-4bc6-9d9f-dcd2c1d828a9",
          type: "text",
          text: "Karnataka, 583239",
          mediaUrl: null,
        },
        {
          id: "51a86788-fcaf-4fc8-8727-7fb162177b88",
          type: "text",
          text: "Bellary,ARH8861JH",
          mediaUrl: null,
        },
        {
          id: "f3f85657-f979-4bd7-9a3d-56e9c5ec0e4a",
          type: "text",
          text: "Hampi, 583239",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "2a022c45-a448-4378-ae3a-f97c1ce5ea70",
      question:
        "You have received an SMS on your mobile. \n\nWhich of the applications shown above will you use to see the SMS?",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "a05f1dcd-a44a-434f-821a-1ec03fe5ab9c",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Main%20Image3dac1ccc-1e1a-4aff-959a-495a3553209d.png",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "58961fcb-da7a-481e-b5f9-b1d6ea9bb40c",
          type: "text",
          text: "2",
          mediaUrl: null,
        },
        {
          id: "4103b537-aaf4-4029-9899-260eee16f7be",
          type: "text",
          text: "1",
          mediaUrl: null,
        },
        {
          id: "056ef60e-d0da-47e2-95bd-25ea69534f30",
          type: "text",
          text: "3",
          mediaUrl: null,
        },
        {
          id: "45d88252-7636-45e1-b710-79b4339c3fb3",
          type: "text",
          text: "4",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "2e846a25-7232-4e43-b03d-228a71d2d093",
      question:
        "You need to find an image on your mobile. \n\nWhich of the applications shown above will you use to find the image?",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "4e9557d0-ec46-4f34-9fa9-5096e7b20692",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Main%20Image%20%281%29dc146179-8aa5-41c4-a6f2-4fd62383886b.png",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "90d20922-8dd5-4f6b-94f3-7173ffebabb9",
          type: "text",
          text: "1",
          mediaUrl: null,
        },
        {
          id: "20b669e0-4126-4fb5-83a0-662a1b6b1944",
          type: "text",
          text: "2",
          mediaUrl: null,
        },
        {
          id: "7513c64d-01d8-4bdc-914d-9cb8fc6def6d",
          type: "text",
          text: "3",
          mediaUrl: null,
        },
        {
          id: "ecae575d-736a-47c1-a6e6-f987ca1d7795",
          type: "text",
          text: "4",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "54fbe277-6d2c-4ec4-8df3-355feda23608",
      question:
        "In the map below what is the time and distance to reach the destination?",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "1b2783e7-db90-448f-88da-3b5048bc6654",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Screenshot%202022-10-19%20at%2011201434af-8f7b-4e10-b5c6-a3de671127d5.png",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "2abc4951-bd48-4450-b49c-36297a88f1c4",
          type: "text",
          text: "1hr 9min, 30KM",
          mediaUrl: null,
        },
        {
          id: "7d0d8105-b88e-4ae0-8d8d-9a930b5ccd4f",
          type: "text",
          text: "1hr 9min, 28KM",
          mediaUrl: null,
        },
        {
          id: "200d249d-ada0-4477-9d7a-1e97351603b5",
          type: "text",
          text: "1hr 13min, 34.1KM",
          mediaUrl: null,
        },
        {
          id: "9e86d0da-67ea-4c73-bcc9-3478e8e71889",
          type: "text",
          text: "1hr 25min, 32.7KM",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "f5ae0317-f0c3-495f-83b2-83dcba6db0f4",
      question:
        "What is the total cost of cargo shipping charges incurred for first 2 days of the month?",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "af54f8d4-24d0-4130-8d46-4f7d755f93ee",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Screenshot%202022-10-26%20at%2015976eb2fd-beb7-4b4d-aace-7d1558248fa2.png",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "a4a198b5-2d14-41a4-89d2-5723112fc3ee",
          type: "text",
          text: "Rs 2,000",
          mediaUrl: null,
        },
        {
          id: "c3c802e9-a723-42e0-9129-e59a55e3062e",
          type: "text",
          text: "Rs 50,000",
          mediaUrl: null,
        },
        {
          id: "d9097941-603f-4c0a-887c-eee74baeeee9",
          type: "text",
          text: "Rs 30,000",
          mediaUrl: null,
        },
        {
          id: "bf6bf326-342c-457a-aaff-f700d380e147",
          type: "text",
          text: "Rs 20,000",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "65f9eb5a-c7ed-4dfd-a854-7bc789c8fff7",
      question:
        "Which animal is in between the two animals that are facing left.",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "228e5f82-f75e-4b7d-b6ca-14510a5ee864",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Group%206%20%284%29862d0abb-6714-47a8-af4f-886a7a3de6e2.png",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "eacb598f-ea52-46bf-9abc-bea917b7189e",
          type: "text",
          text: "Fish",
          mediaUrl: null,
        },
        {
          id: "fe72776d-a9a2-44e1-bf6b-25b3ca66e2a9",
          type: "text",
          text: "Dog",
          mediaUrl: null,
        },
        {
          id: "89475878-b0dd-4370-a4df-55fc06fc7269",
          type: "text",
          text: "Elephant",
          mediaUrl: null,
        },
        {
          id: "4b655dad-006d-4c39-af05-00e6f719fbe5",
          type: "text",
          text: "Monkey",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "63fdffd6-0e67-4538-a0fb-e9bcaacc3cf4",
      question: "which of the following matches pattern below?",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "590525a4-3564-4fc2-b14a-0a8332fd1789",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Group%206%20%285%2974bb9645-361b-4979-9c29-19ecc773bb38.png",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "a0a506ed-0351-46df-be84-1b7bc312ee75",
          type: "text",
          text: "1.23”m/$/*m",
          mediaUrl: null,
        },
        {
          id: "fccf1ec3-6774-4cfd-ad87-d6618f613bc5",
          type: "text",
          text: '1.28"m/$/*m',
          mediaUrl: null,
        },
        {
          id: "48a96eff-d517-40ad-b03b-c4534e5b79cb",
          type: "text",
          text: "1.23”m/S/*m",
          mediaUrl: null,
        },
        {
          id: "e33d1ccd-7742-4d07-a43b-f1695649576f",
          type: "text",
          text: "1.23’m/$/*m",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "8ddd9642-a40c-4ddc-a7e8-26342bcca61a",
      question: "Please select the  number that matches the one given below.",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "1d2e80fa-55e5-4346-8a73-80748349cce7",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/12d7ded88e-2494-4975-95de-24e1aea9da5a.jpeg",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "95aeab94-043a-40a6-b1e7-6cb473c971b9",
          type: "text",
          text: "GL17Y9394",
          mediaUrl: null,
        },
        {
          id: "98da4f8f-4418-49a5-9afe-10dfcb6e911c",
          type: "text",
          text: "GJ17Y9394",
          mediaUrl: null,
        },
        {
          id: "e4ca6793-3885-4fc1-8c66-38ad358a3236",
          type: "text",
          text: "GJ17Y9934",
          mediaUrl: null,
        },
        {
          id: "0620e260-15d5-4554-a5b6-66206b05984c",
          type: "text",
          text: "GJ117Y9394",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "9553af52-9704-4166-bf9d-2ab3db9e850a",
      question: "Please categorize the following package.",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "75e31e38-7b32-4a19-ad3d-b780b5e25539",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Group%2014%20%283%296d9730c0-7d43-457b-8db0-b87b537406e9.png",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "f5e3eab1-2bd0-4188-a82a-1e978f68e466",
          type: "text",
          text: "Urgent, To Delhi",
          mediaUrl: null,
        },
        {
          id: "b34cde2a-0df8-46b6-abe2-6785dbea3201",
          type: "text",
          text: "Urgent, To Mumbai",
          mediaUrl: null,
        },
        {
          id: "598ba4fb-86bc-4e70-81fb-1eb96e0c361a",
          type: "text",
          text: "Urgent, To Goa",
          mediaUrl: null,
        },
        {
          id: "29bf65e7-4cfa-4b0b-88d7-527b6c6eb37d",
          type: "text",
          text: "Heavy, To Goa",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "a88edeb7-c893-4ae5-8986-c50821bc01dd",
      question: "Please categorize the following package.",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "174323a8-7d50-4caa-839e-682255379c46",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Group%2014%20%285%29ae2cf6b6-c8f0-48e1-9912-4775028a5b70.png",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "d91e1060-0b31-416e-9cc2-6a477a5b4d84",
          type: "text",
          text: "Heavy",
          mediaUrl: null,
        },
        {
          id: "0c368218-2a53-4aa4-90f9-266c360ef493",
          type: "text",
          text: "Urgent",
          mediaUrl: null,
        },
        {
          id: "c98e51e7-c10b-464a-8fbe-624acb086561",
          type: "text",
          text: "Fragile",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "56b0cf3d-744e-4cde-94fa-e02b74e03a7f",
      question: "Please categorize the following package.",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "8cdb3bbb-1d11-4d70-a6bd-b6481c7a5427",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Group%2014%20%286%29ae08468f-d6e5-4549-a7af-c29a7bfb6f11.png",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "ed4e2ec0-b459-4898-a642-d038760b5618",
          type: "text",
          text: "> 200 KG",
          mediaUrl: null,
        },
        {
          id: "9a36edbf-1a86-4cee-af81-2eeeb9ab317b",
          type: "text",
          text: "50 - 200 KG",
          mediaUrl: null,
        },
        {
          id: "c334550b-920f-4f01-92af-e74ee1e1aeeb",
          type: "text",
          text: "10 - 50 KG",
          mediaUrl: null,
        },
        {
          id: "2c653831-5ef1-45f7-bf2a-334399d4e16f",
          type: "text",
          text: "0 - 10 KG",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "7de02fd7-2385-4681-9b22-98acc2a2dff0",
      question:
        "You have 4 production machines with with output per hour given below. What's the average output per machine per hour?",
      type: "mcq",
      timer: null,
      media: [
        {
          mediaId: "ad36ddd4-b387-4c6b-bc8d-5a07055973aa",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/Group%20645ea53c9-3cc6-484f-934f-7019e1bbd438.jpeg",
          mediaType: "image",
        },
      ],
      options: [
        {
          id: "e6cd10b2-99fe-4dce-8b65-753e8740b5a8",
          type: "text",
          text: "300",
          mediaUrl: null,
        },
        {
          id: "a3adcb61-ed6a-444f-8fd5-84adf4d8849f",
          type: "text",
          text: "450",
          mediaUrl: null,
        },
        {
          id: "0d381326-bb5b-46b3-bb13-0e0b1c2d2b6b",
          type: "text",
          text: "400",
          mediaUrl: null,
        },
        {
          id: "6e6c69ce-c44c-49a4-9a8b-daa97ff3abbd",
          type: "text",
          text: "350",
          mediaUrl: null,
        },
      ],
    },
    {
      id: "0f1ec293-a286-405d-8267-b3aae9fe6ba7",
      question:
        "If 500 shipments arrived, 23 got rejected, 8 broke down. How many will be sent to customers now?",
      type: "mcq",
      timer: null,
      media: [],
      options: [
        {
          id: "90e1431c-461b-4fa1-8a43-6e007b0d89c1",
          type: "text",
          text: "489",
          mediaUrl: null,
        },
        {
          id: "2e879170-8f04-4db8-b1bd-22b268391a43",
          type: "text",
          text: "459",
          mediaUrl: null,
        },
        {
          id: "64df41ad-82aa-4e6d-9436-88bd419d9f92",
          type: "text",
          text: "469",
          mediaUrl: null,
        },
        {
          id: "c4f6a1b5-3bb7-4a2c-8b12-8ce4b040645f",
          type: "text",
          text: "471",
          mediaUrl: null,
        },
      ],
    },
  ],
  totalTimeSpent: null,
  lastQuestionId: null,
};

export const SPEECH_QUIZ = {
  id: "6bb2148b-6e9c-4985-9cbd-61882c6ce5ac",
  title: "Speech Assessment",
  timer: 0,
  description:
    "You’ll be presented with some sentences and paragraphs. Speak out the text on the screen using the mic",
  questions: [
    {
      id: "46f9057f-cf85-426e-8a96-c2b295a5894f",
      question:
        "<p>I'd like to see the North Pole, but I will never go where it is that cold</p>",
      type: "speech_scripted",
      timer: null,
      media: [
        {
          mediaId: "e132f2d2-1b12-4d79-9e5b-2fadf18b0700",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/pexels-valdemaras-d-16708458b258549-d3a4-4542-87c3-7034aa5c4e7d.jpeg",
          mediaType: "image",
        },
      ],
      maxScore: 1,
      options: [],
      order: 0,
    },
    {
      id: "0fc87746-242c-4d6d-aebc-1a4fa067438c",
      question:
        "<p>I think so. In my country, old people are respected by the society because they have wisdom to offer. When they speak, we need to pay attention and not talk back. People will judge you if you are not kind or patient with seniors. In my culture, life is like a cycle , when you were young, parents and grandparents took care of you, now they are old, it is your responsibility to take care of them. It is plain and simple.</p><p><br></p>",
      type: "speech_spontaneous",
      timer: null,
      media: [],
      maxScore: 1,
      options: [],
      order: 1,
    },
    {
      id: "a68a6d40-267e-461c-864a-38f095d69bf5",
      question:
        "<h4><strong>Record your answer</strong></h4><h4>Next up, you'll be asked a question. Tell us your thoughts in about 30-60 seconds.</h4>",
      type: "breaker_screen",
      timer: null,
      media: [
        {
          mediaId: "db415273-5d14-45a1-bf1d-0e8fd8561bf8",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/splash-screen-img0e2b64a4-a815-4a9d-bd12-c43b9b7bccd0.svg%2Bxml",
          mediaType: "image",
        },
      ],
      maxScore: 1,
      options: [
        {
          id: "6f921891-bb0f-4910-b8dd-ebe1be2782a0",
          type: "text",
          text: "Continue",
          mediaUrl: null,
          embedUrl: null,
        },
      ],
      order: 2,
    },
    {
      id: "3bfd0822-780e-4625-9a55-1271235eeeb3",
      question: "<p>How would you handle an angry customer on a call?</p>",
      type: "speech_spontaneous",
      timer: null,
      media: [
        {
          mediaId: "495d1a62-2b0e-4f02-b139-54df6946b349",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/spontaneous+speech+question4072cb9f-43a3-4fdf-8ae1-ea8d58222ee5.mp4",
          mediaType: "video",
        },
      ],
      maxScore: 1,
      options: [],
      order: 3,
    },
  ],
  totalTimeSpent: null,
  lastQuestionId: null,
  media: {
    id: "dba74337-b19a-4861-baa1-02aa6d5a7830",
    link: "https://unberry.s3.ap-south-1.amazonaws.com/unberry/splash-screen-img.ba489f0365202fa9132f90d75a4c4896.png",
  },
};

export const TYPING_QUIZ = {
  id: "6bb2148b-6e9c-4985-9cbd-61882c6ce5ac",
  title: "Typing Assessment",
  timer: 0,
  description: "Assess your typing skills",
  questions: [
    {
      id: "46f9057f-cf85-426e-8a96-c2b295a5",
      question: "The quick [blank] fox jumps [blank] the lazy dog.",
      type: QUESTION_TYPE.TEXT_COMPLETION,
      timer: null,
      media: [],
      maxScore: 1,
      options: [],
      order: 0,
    },
    {
      id: "46f9057f-cf85-426e-8a96-c2b295a5894f",
      question: "The quick brown fox jumps over the lazy dog.",
      type: QUESTION_TYPE.TYPING_TEST,
      timer: null,
      media: [],
      maxScore: 1,
      options: [],
      order: 0,
    },
    {
      id: "46f9057f-cf85-426e-8a96-123",
      question: "Don't forget to close the door when you leave.",
      type: QUESTION_TYPE.TYPING_TEST,
      timer: null,
      media: [
        {
          mediaId: "dummy-audio-1",
          mediaUrl:
            "https://www.englishclub.com/audio/listening/dictation/s5-command-requests-1a.mp3",

          mediaType: "audio",
        },
      ],
      maxScore: 1,
      options: [],
      order: 0,
    },
    {
      id: "0fc87746-242c-4d6d-aebc-1a4fa067438c",
      question:
        "I think so. In my country, old people are respected by the society because they have wisdom to offer. When they speak, we need to pay attention and not talk back. People will judge you if you are not kind or patient with seniors. In my culture, life is like a cycle , when you were young, parents and grandparents took care of you, now they are old, it is your responsibility to take care of them. It is plain and simple.",
      type: QUESTION_TYPE.TYPING_TEST,
      timer: null,
      media: [],
      maxScore: 1,
      options: [],
      order: 1,
    },
    {
      id: "a68a6d40-267e-461c-864a-38f095d69bf5",
      question:
        "Record your answer Next up, you'll be asked a question. Tell us your thoughts in about 30-60 seconds.",
      type: QUESTION_TYPE.TYPING_TEST,
      timer: null,
      media: [
        {
          mediaId: "db415273-5d14-45a1-bf1d-0e8fd8561bf8",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/splash-screen-img0e2b64a4-a815-4a9d-bd12-c43b9b7bccd0.svg%2Bxml",
          mediaType: "image",
        },
      ],
      maxScore: 1,
      options: [],
      order: 2,
    },
    {
      id: "3bfd0822-780e-4625-9a55-1271235eeeb3",
      question: "How would you handle an angry customer on a call?",
      type: QUESTION_TYPE.TYPING_TEST,
      timer: null,
      media: [
        {
          mediaId: "495d1a62-2b0e-4f02-b139-54df6946b349",
          mediaUrl:
            "https://unberry.s3.ap-south-1.amazonaws.com/unberry/spontaneous+speech+question4072cb9f-43a3-4fdf-8ae1-ea8d58222ee5.mp4",
          mediaType: "video",
        },
      ],
      maxScore: 1,
      options: [],
      order: 3,
    },
  ],
  totalTimeSpent: null,
  lastQuestionId: null,
  media: {
    id: "dba74337-b19a-4861-baa1-02aa6d5a7830",
    link: "https://unberry.s3.ap-south-1.amazonaws.com/unberry/splash-screen-img.ba489f0365202fa9132f90d75a4c4896.png",
  },
};
